import { useState, useRef, useEffect } from 'react';
import { useTranslation } from '~/lib/hooks/useTranslation';
import { classNames } from '~/utils/classNames';

const languages = [
  { code: 'en', name: 'English', displayName: 'EN  English' },
  { code: 'pt', name: 'Português', displayName: 'PT  Português' },
  { code: 'tr', name: 'Türkçe', displayName: 'TR  Türkçe' },
  { code: 'ru', name: 'Русский', displayName: 'RU  Русский' },
];

export function LanguageSwitcher() {
  const { currentLanguage, changeLanguage } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const currentLang = languages.find((lang) => lang.code === currentLanguage) || languages[0];

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (langCode: string) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1.5 px-3 h-[35px] rounded-md bg-dualite-background-button text-dualite-text-primary hover:bg-dualite-background-button-hover transition-colors duration-150"
        aria-label="Change language"
      >
        <div className="i-ph:globe w-[14px] h-[14px]" />
        <span className="text-xs font-medium">{currentLang.code.toUpperCase()}</span>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-48 bg-dualite-background-tertiary border border-dualite-border-primary rounded-2xl shadow-xl z-50 overflow-hidden">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={classNames(
                'w-full flex items-center justify-between px-4 py-3 text-left transition-colors',
                'hover:bg-dualite-background-button-hover text-dualite-text-primary',
                currentLanguage === lang.code
                  ? 'bg-dualite-background-button-hover'
                  : 'hover:bg-dualite-background-button-hover',
              )}
            >
              <span className="text-sm font-medium">{lang.displayName}</span>
              {currentLanguage === lang.code && <div className="i-ph:check-bold w-4 h-4 text-dualite-text-primary" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
